import FeatureFlagsHelper from '@app/helper/featureflags';

export const featureFlagsInit = () => {
  // Check if a user has teams
  if (
    window['__session__'] &&
    window['__session__'].account &&
    window['__session__'].account.has_teams
  ) {
    FeatureFlagsHelper.hasTeams = true;
  }

  // Check if we can show the new plus page
  if (
    window['__feature_flags__'] &&
    window['__feature_flags__'].unlimited_transfer_offer &&
    window['__feature_flags__'].unlimited_transfer_offer.enabled
  ) {
    FeatureFlagsHelper.unlimitedTransfers = true;
  }
};

featureFlagsInit();
